var React = require('react');

function UserGrid3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.15","fillRule":"evenodd","clipRule":"evenodd","d":"M95.5773 130.664C65.1287 183.021 160.479 239.198 191.357 297.997C220.366 353.238 213.625 421.639 268.272 459.516C331.507 503.344 418.271 525.292 485.717 502.021C551.769 479.23 578.44 411.563 591.268 348.07C601.844 295.718 585.238 238.754 548.473 191.385C518.057 152.198 465.553 137.269 416.123 122.413C375.799 110.293 338.067 114.833 297.268 115.884C226.732 117.699 126.763 77.041 95.5773 130.664Z","fill":"#709BE7"}));
}

UserGrid3.defaultProps = {"width":"657","height":"569","viewBox":"0 0 657 569","fill":"none"};

module.exports = UserGrid3;

UserGrid3.default = UserGrid3;
